module.exports = __webpack_public_path__ + "img/gb9128_1_a.prt.a0462ecc.jpg";